<div class="lum-c-order-fulfillment-items-table relative">
  <table class="lum-table lum-table--classic striped">
    <thead>
      <tr class="table__head-row">
        <th>SKU</th>
        <th>Name</th>
        <th class="text-center">Qty Fulfilled</th>
        <th class="text-center">Lot</th>
        <th class="text-center">Cost</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let fulfillmentOrderItem of fulfillmentOrderItems">
        <tr>
          <td>{{ fulfillmentOrderItem.sku }}</td>
          <td>{{ fulfillmentOrderItem.name }}</td>
          <td class="text-center">{{
            fulfillmentOrderItem.quantity | decimalPlaces
          }}</td>
          <td class="text-center">{{ fulfillmentOrderItem.lot }}</td>
          <td class="text-center">{{
            fulfillmentOrderItem.quantity * fulfillmentOrderItem.unitPrice
              | currency: ''
          }}</td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
